import './Button.scss';

import clsx from 'clsx';
import { noop } from 'lodash-es';
import { Component } from 'react';
import { ReactComponent as CollapseIcon } from 'resources/svg/icons/Collapse.svg';

import Icon from '../Image/Image';
import MakeLink from '../MakeLink/MakeLink';

export default class Button extends Component<$TSFixMe, $TSFixMe> {
  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    content: null,
    extraLarge: false,
    large: false,
    small: false,
    disabled: false,
    disabledInverted: false,
    blackInverted: false,
    black: false,
    green: false,
    left: false,
    right: false,
    title: null,
    tooltipMaxWidth: false,
    tooltipTrigger: 'hover',
    tooltipPlacement: 'bottom',
    type: 'button',
    onClick: noop,
    onBlur: noop,
    mouseOverAction: noop,
    mouseLeaveAction: noop,
    focusAction: noop,
  };

  classGenerator = () => {
    const {
      default: defaultProp,
      className,
      icon,
      left,
      right,
      square,
      small,
      large,
      extraLarge,
      disabled,
      disabledInverted,
      black,
      green,
      blue,
      blueInverted,
      defaultInverted,
      blackInverted,
      whiteInverted,
      greyInverted,
      greenInverted,
      orange,
      tertiary,
      orangeInverted,
      alibabaGrey,
      tooltipTrigger,
      isLoading,
    } = this.props;

    // Return
    return clsx(
      'btn',
      {
        'btn-xl': extraLarge,
        'btn-l': large,
        'btn-s': small,
        'btn-sq': square,
        'btn-disabled': disabled,
        'btn-disabled-inverted': disabledInverted,
        'btn-default': defaultProp,
        'btn-black': black,
        'btn-white-inverted': whiteInverted,
        'btn-green': green,
        'btn-default-inverted': defaultInverted,
        'btn-black-inverted': blackInverted,
        'btn-grey-inverted': greyInverted,
        'btn-green-inverted': greenInverted,
        'btn-blue': blue,
        'btn-blue-inverted': blueInverted,
        'btn-orange': orange,
        'btn-orange-inverted': orangeInverted,
        'btn-alibaba-grey': alibabaGrey,
        'btn-tertiary': tertiary,
        'btn-isLoading': isLoading,
        'btn-withIcon': icon,
        'btn-left': left,
        'btn-right': right,
      },
      className,
      tooltipTrigger,
    );
  };

  render() {
    // TODO: Check the possibility of merging the code for disabled button and not because the condition seems unecessary
    const {
      id,
      disabled,
      disabledInverted,
      icon,
      content,
      title,
      tooltipPlacement,
      tooltipMaxWidth,
      tooltipTrigger,
      tooltipHoverable,
      tooltipOffsetX,
      tooltipActions,
      type,
      dropdown,
      onClick,
      onBlur,
      mouseOverAction,
      mouseLeaveAction,
      focusAction,
      isLoading,
      isLink,
    } = this.props;

    const IconComponent = icon?.Component ?? null;

    return (
      <MakeLink
        title={title}
        onBlur={onBlur}
        isLink={isLink}
        tooltipTrigger={tooltipTrigger}
        tooltipHoverable={tooltipHoverable}
        tooltipPlacement={tooltipPlacement}
        tooltipOffsetX={tooltipOffsetX}
        tooltipMaxWidth={tooltipMaxWidth}
        offsetY={6}
        tooltipActions={tooltipActions}
      >
        <button
          id={id || ''}
          // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: any[]; id: any; reference: strin... Remove this comment to see the full error message
          reference="true"
          type={type}
          className={this.classGenerator()}
          onClick={(e) => {
            if (isLoading || disabled || disabledInverted) {
              return;
            }

            /* NOTE: As soon there is a click to go to next step I'm bluring the clicked button because when clicked it gets 'focused'
                                                 by default, and in that situation the user goes to the next step and he immediately sees the error tooltip (If there is one)
                                                 That behaviour is undesired
                                        */
            if (tooltipTrigger === 'focus') {
              (e.target as $TSFixMe).blur();
            }

            onClick(e);
          }}
          onMouseOver={mouseOverAction}
          onMouseOut={mouseLeaveAction}
          onBlur={onBlur}
          onFocus={focusAction}
        >
          {icon && <Icon name={icon.name}>{IconComponent && <IconComponent />}</Icon>}
          {content}
          {dropdown && (
            <Icon className="icon-dropdown" name="Collapse">
              <CollapseIcon />
            </Icon>
          )}
          {isLoading && !icon && <Icon name="Loading" />}
        </button>
      </MakeLink>
    );
  }
}
